var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"display"}},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.hours))]),_vm._v(": "),_c('span',[_vm._v(_vm._s(_vm.minutes))]),_vm._v(": "),_c('span',{class:{ highlight: !_vm.timerRunning }},[_vm._v(_vm._s(_vm.seconds))])])])}
var staticRenderFns = []

export { render, staticRenderFns }